var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #062860;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M34.03,265.97V63.05H5v202.92c0,7.95,2.77,14.81,8.43,20.59,5.66,5.66,12.64,8.43,20.59,8.43h202.92v-29.02H34.03Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M286.45,13.55c-5.66-5.66-12.53-8.55-20.47-8.55H92.07c-8.07,0-14.93,2.89-20.59,8.55-5.66,5.66-8.43,12.52-8.43,20.47v173.9c0,7.95,2.77,14.81,8.43,20.59,5.66,5.66,12.53,8.43,20.59,8.43h173.9c7.95,0,14.81-2.77,20.47-8.43,5.66-5.78,8.55-12.64,8.55-20.59V34.03c0-7.95-2.89-14.81-8.55-20.47ZM236.95,34.03v101.4l-36.25-21.68-36.13,21.68V34.03h72.38Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLibrary);
export default __webpack_public_path__ + "static/media/icon_library.49454f1f726b18625929b465ffcd8c34.svg";
export { ForwardRef as ReactComponent };